import { render } from "./LogoInfo.vue?vue&type=template&id=2736858c&scoped=true"
import script from "./LogoInfo.vue?vue&type=script&lang=js"
export * from "./LogoInfo.vue?vue&type=script&lang=js"

import "./LogoInfo.vue?vue&type=style&index=0&id=2736858c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2736858c"]])

export default __exports__